import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Loading, ErrorState } from "@/components/common";
import { Card } from "@/components/ui/card";
import { Mail, UserCheck, FileEdit, FileCheck2, GitPullRequest, Users } from "lucide-react";

const CARDS = [
  { key: "invited", label: "Invited", icon: Mail, color: "text-slate-600 bg-slate-100" },
  { key: "signed_up", label: "Signed up", icon: UserCheck, color: "text-blue-600 bg-blue-50" },
  { key: "draft", label: "Draft forms", icon: FileEdit, color: "text-amber-600 bg-amber-50" },
  { key: "submitted", label: "Submitted", icon: FileCheck2, color: "text-emerald-600 bg-emerald-50" },
  { key: "change_requests", label: "Change requests", icon: GitPullRequest, color: "text-orange-600 bg-orange-50" },
  { key: "total_employees", label: "Total employees", icon: Users, color: "text-indigo-600 bg-indigo-50" },
];

export default function Dashboard() {
  const { actingOrgId } = useAuth();
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["dashboard", actingOrgId],
    queryFn: async () => (await api.get("/org/dashboard")).data,
  });

  return (
    <div>
      <PageHeader title="Dashboard" description={data?.org_name ? `Overview for ${data.org_name}` : "Overview"} />
      {isLoading ? <Loading /> : isError ? <ErrorState error={error} onRetry={refetch} /> : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {CARDS.map((c) => (
            <Card key={c.key} className="p-5" data-testid={`stat-${c.key}`}>
              <div className={`mb-3 flex h-10 w-10 items-center justify-center rounded-lg ${c.color}`}>
                <c.icon className="h-5 w-5" />
              </div>
              <p className="text-3xl font-bold text-slate-900">{data?.[c.key] ?? 0}</p>
              <p className="mt-1 text-sm text-slate-500">{c.label}</p>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
